module.exports = __webpack_public_path__ + "img/ON-04.d6f9577d.svg";